/**
 * Cart recommendations carousel.
 *
 * Extends the base SliderComponent so the arrows scroll a full page of visible
 * slides (4 from tablet up, 1 on mobile) instead of a single slide.
 */
(() => {
  if (typeof SliderComponent === 'undefined' || customElements.get('cart-recommendations-slider')) return;

  const MULTI_COLUMN_MEDIA_QUERY = '(min-width: 768px)';
  const MULTI_COLUMN_SLIDES_PER_STEP = 4;
  const DEFAULT_SLIDES_PER_STEP = 1;

  class CartRecommendationsSlider extends SliderComponent {
    /**
     * Number of slides scrolled on each arrow click, matching the slides per view.
     *
     * @returns {number} The amount of slides to scroll.
     */
    get slidesPerStep() {
      return window.matchMedia(MULTI_COLUMN_MEDIA_QUERY).matches
        ? MULTI_COLUMN_SLIDES_PER_STEP
        : DEFAULT_SLIDES_PER_STEP;
    }

    /**
     * Scrolls the slider by a full page of slides.
     *
     * @param {MouseEvent} event - The click event fired by a slider arrow.
     */
    onButtonClick(event) {
      event.preventDefault();

      const direction = event.currentTarget.name === 'next' ? 1 : -1;
      const offset = this.sliderItemOffset ?? 0;

      this.setSlidePosition(this.slider.scrollLeft + direction * this.slidesPerStep * offset);
    }
  }

  customElements.define('cart-recommendations-slider', CartRecommendationsSlider);
})();
